import { render, staticRenderFns } from "./withdrawLogo.vue?vue&type=template&id=3818b71e"
import script from "./withdrawLogo.vue?vue&type=script&lang=js"
export * from "./withdrawLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports